const doArchiveStory = id => ({
    type: 'ARCHIVE_STORY',
    id,
  });
   
  export {
    doArchiveStory
  };